import React, { useState, useRef } from "react";
import { Form, OverlayTrigger, Popover } from "react-bootstrap";
import { DayPicker } from "react-day-picker";
import { format } from "date-fns";
import "react-day-picker/dist/style.css";
import { DATE_TYPES } from "configurations/Constants";

function DatePicker({
  label,
  date,
  onChange,
  isInvalid,
  handleDisabledDates,
  disabled,
}) {
  const [showPicker, setShowPicker] = useState(false);
  const targetRef = useRef(null);

  const formattedDate = date ? format(date, "MM/dd/yyyy") : "";

  const handleSelect = (selectedDate) => {
    onChange(selectedDate);
    setShowPicker(false);
  };

  const popover = (
    <Popover id="calendar-popover">
      <Popover.Body>
        <DayPicker
          mode={DATE_TYPES.SINGLE}
          selected={date}
          onSelect={handleSelect}
          disabled={handleDisabledDates}
        />
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      {label && <Form.Label>{label}</Form.Label>}
      <OverlayTrigger
        trigger="click"
        placement="top"
        overlay={popover}
        show={showPicker}
        onToggle={() => setShowPicker(!showPicker)}
        rootClose
      >
        <div
          className="position-relative"
          ref={targetRef}
          onClick={() => setShowPicker(!showPicker)}
          style={{ cursor: "pointer" }}
        >
          <Form.Control
            readOnly
            type="text"
            value={formattedDate}
            placeholder="MM/DD/YYYY"
            className="input-underline"
            disabled={disabled}
            isInvalid={isInvalid}
          />
          <i className="fa-regular fa-calendar position-absolute end-0 top-50 translate-middle-y p-2 text-muted"></i>
        </div>
      </OverlayTrigger>
    </>
  );
}

export default DatePicker;
